import { render, staticRenderFns } from "./activate.vue?vue&type=template&id=2cfdfd60&scoped=true&"
import script from "./activate.vue?vue&type=script&lang=js&"
export * from "./activate.vue?vue&type=script&lang=js&"
import style0 from "./activate.vue?vue&type=style&index=0&id=2cfdfd60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfdfd60",
  null
  
)

export default component.exports